module.exports = __webpack_public_path__ + "static/media/sparkles.0a44e1dc.svg";